var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"templateData h100"},[_c('el-card',[_c('h1',[_vm._v("This is an templateData page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }